"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9535],{

/***/ 29535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pop_up_open_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 23 modules
var dialog = __webpack_require__(65518);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./public/assets/icons/ExitPopUp.svg
var ExitPopUp = __webpack_require__(61740);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(80261);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3561);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(51315);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}

// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
;// CONCATENATED MODULE: ./components/atoms/countdown/Countdown.tsx
"use client";





function CountdownTimer(param) {
    var countdown = param.countdown, title = param.title, subtitle = param.subtitle, _className = param.className, className = _className === void 0 ? "" : _className;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var ref = (0,react.useState)(null), timeLeft = ref[0], setTimeLeft = ref[1];
    var target = (0,react.useMemo)(function() {
        if (!countdown) return null;
        if ((0,_instanceof/* default */.Z)(countdown, Date)) return countdown.getTime();
        var s = String(countdown);
        var parts = s.split("/");
        if (parts.length === 3) {
            var ref = _slicedToArray(parts.map(Number), 3), dd = ref[0], mm = ref[1], yyyy = ref[2];
            return new Date(yyyy, (mm !== null && mm !== void 0 ? mm : 1) - 1, dd !== null && dd !== void 0 ? dd : 1).getTime();
        }
        var n = new Date(s).getTime();
        return Number.isFinite(n) ? n : null;
    }, [
        countdown
    ]);
    (0,react.useEffect)(function() {
        if (target === null) return;
        var tick = function() {
            var now = Date.now();
            var diff = Math.max(0, target - now);
            var days = Math.floor(diff / 86400000);
            var hours = Math.floor(diff % 86400000 / 3600000);
            var minutes = Math.floor(diff % 3600000 / 60000);
            var seconds = Math.floor(diff % 60000 / 1000);
            if (diff <= 0) {
                setTimeLeft(null);
                return;
            }
            setTimeLeft({
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds
            });
        };
        tick();
        var id = window.setInterval(tick, 1000);
        return function() {
            return window.clearInterval(id);
        };
    }, [
        target
    ]);
    if (!countdown || !timeLeft) return null;
    var z2 = function(n) {
        return String(n).padStart(2, "0");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[24px] font-bold",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-2 flex justify-center gap-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[28px]",
                                children: z2(timeLeft.days)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[10px] font-bold uppercase",
                                children: t("popupDates.days")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[28px]",
                                children: z2(timeLeft.hours)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[10px] font-bold uppercase",
                                children: t("popupDates.hours")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[28px]",
                                children: z2(timeLeft.minutes)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[10px] font-bold uppercase",
                                children: t("popupDates.minutes")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[28px]",
                                children: z2(timeLeft.seconds)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[10px] font-bold uppercase",
                                children: t("popupDates.secs")
                            })
                        ]
                    })
                ]
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "opacity-70",
                children: subtitle
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/organisms/pop-up-open-page/PopUpOpenPage.tsx







/**
 * PopUpOpenPage
 */ var PopUpOpenPage = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, title = param.title, button = param.button, desc = param.desc, image = param.image, link = param.link, idPopUp = param.idPopUp, buttonClosesPopup = param.buttonClosesPopup, countdown = param.countdown, countdownTitle = param.countdownTitle, countdownSubtitle = param.countdownSubtitle, autoApertura = param.autoApertura;
    var ref = (0,react.useState)(false), popUpOpen = ref[0], setPopUpOpen = ref[1];
    var panel = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var isModalShown = window.sessionStorage.getItem(idPopUp);
        if (isModalShown !== "Shown") {
            setPopUpOpen(true);
            sessionStorage.setItem(idPopUp, "Shown");
        } else {
            autoApertura ? setPopUpOpen(true) : setPopUpOpen(false);
        }
    }, []);
    var togglePopUp = function() {
        setPopUpOpen(!popUpOpen);
    };
    var _src;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
        open: popUpOpen,
        // eslint-disable-next-line
        onClose: function() {},
        className: "absolute inset-0 z-50 grid place-items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Overlay */.V.Overlay, {
                className: "absolute inset-0 bg-[rgba(21,33,39,0.7)]",
                onClick: togglePopUp
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                className: "popup-container z-50 flex h-fit w-[calc(100vw-2rem)] flex-col items-center overflow-hidden bg-[#F9F0EB] font-primary lg:w-[1080px] lg:flex-row ".concat(className),
                children: [
                    image && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "popup-img-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                layout: "fill",
                                src: image,
                                className: "object-cover"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "popup-img",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopUp["default"], {
                                    height: 32,
                                    width: 32,
                                    className: "flex-shrink-0 hover:cursor-pointer",
                                    onClick: togglePopUp
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: panel,
                        className: "popup-text-container relative text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex h-full flex-col justify-evenly ".concat(image ? "" : "px-10 md:px-[100px]"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden justify-end md:absolute md:right-2 md:top-2 md:flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopUp["default"], {
                                        height: 32,
                                        width: 32,
                                        className: "flex-shrink-0 hover:cursor-pointer",
                                        onClick: togglePopUp
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col justify-center gap-3 md:gap-6 ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col gap-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-[32px] font-bold leading-[36px] md:text-[48px] md:leading-[52px]",
                                                    children: title
                                                }),
                                                desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "popup-desc text-[14px] md:text-[20px]",
                                                    dangerouslySetInnerHTML: {
                                                        __html: desc
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-[2rem] lg:mb-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownTimer, {
                                                countdown: countdown,
                                                title: countdownTitle,
                                                subtitle: countdownSubtitle
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col flex-wrap content-center justify-between gap-3",
                                    children: [
                                        button.label && (buttonClosesPopup ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                            className: "popup-buttons whitespace-nowrap",
                                            size: "large",
                                            variant: button.variant,
                                            onClick: togglePopUp,
                                            children: button.label
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                            className: "popup-buttons whitespace-nowrap",
                                            size: "large",
                                            as: "a",
                                            href: button.src,
                                            variant: button.variant,
                                            children: button.label
                                        })),
                                        link.label && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                            arrow: true,
                                            className: "mx-auto flex flex justify-center self-center md:w-[50%] md:items-center md:self-start md:pl-2 md:pt-3",
                                            variant: link.variant,
                                            href: (_src = link.src) !== null && _src !== void 0 ? _src : "#",
                                            children: link.label
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
PopUpOpenPage.displayName = "PopUpOpenPage";

;// CONCATENATED MODULE: ./components/organisms/pop-up-open-page/index.ts

/* harmony default export */ var pop_up_open_page = (PopUpOpenPage);


/***/ }),

/***/ 80261:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

}]);